import React, { useState, useEffect } from 'react';
import '../TransactionHistory/transactionHistory.css';
import './actionLogs.css';
import axios from 'axios';

interface Log {
  id: string;
  timestamp: string;
  action: string;
  details: any;
  user_name: string | null;
  admin_username: string | null;
}

const ACTION_LABELS: Record<string, string> = {
  purchase_created: 'קנייה נוצרה',
  purchase_deleted: 'קנייה נמחקה',
  transfer_created: 'העברה נוצרה',
  transfer_deleted: 'העברה נמחקה',
};

const ActionLogs: React.FC = () => {
  const [logs, setLogs] = useState<Log[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    try {
      setIsLoading(true);
      setError('');
      const result = await axios.get('https://kaskas.pro/split-bill-server/get-logs');
      setLogs(result.data);
    } catch (err: any) {
      setError('אירעה שגיאה בטעינת היומן');
    } finally {
      setIsLoading(false);
    }
  };

  const formatDatetime = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('he-IL', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const formatDetails = (details: any): string => {
    if (!details) return '';
    const parts: string[] = [];
    if (details.description) parts.push(`תיאור: ${details.description}`);
    if (details.amount !== undefined) parts.push(`סכום: ₪${details.amount}`);
    if (details.paid_user_id !== undefined) parts.push(`משלם: ${details.paid_user_id}`);
    if (details.received_user_id !== undefined) parts.push(`מקבל: ${details.received_user_id}`);
    return parts.join(' | ');
  };

  return (
    <div className="transaction-history">
      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
        </div>
      )}
      <h2 className="transaction-history__title">יומן פעולות</h2>
      {error && <p className="logs-error">{error}</p>}
      <div className="transaction-list">
        {logs.length > 0 ? (
          logs.map((log) => (
            <div key={log.id} className="transaction-card log-card">
              <div className="transaction-card__header">
                <span className="transaction-card__date">{formatDatetime(log.timestamp)}</span>
                <span className={`log-action-badge log-action-badge--${log.action}`}>
                  {ACTION_LABELS[log.action] || log.action}
                </span>
              </div>
              <div className="transaction-card__body">
                {log.admin_username && (
                  <div className="log-admin">
                    בוצע ע"י: <strong>{log.admin_username}</strong>
                  </div>
                )}
                {log.user_name && (
                  <div className="log-user">
                    משתמש: <strong>{log.user_name}</strong>
                  </div>
                )}
                {log.details && (
                  <div className="log-details">{formatDetails(log.details)}</div>
                )}
              </div>
            </div>
          ))
        ) : (
          !isLoading && (
            <div className="empty-filter-results">
              <p>אין פעולות להצגה</p>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default ActionLogs;
